<template>
  <div class="bg-white">
    <CommHeader />
    <CommSwipe :dataList="swipeDataList" />
    <div class="container">
      <div class="common-margin-top row">
        <div class="col col-12 col-md-6 col-lg-6  common-padding-top">
          <p class="common-letter-spacing common-line-height-2-5 common-padding-top">
            <span class="common-margin-left"></span>某返利APP，在平台商城消费的金额，一定的比例通过逐日返还给
          消费者积分，1积分=1元，积分可以消费，鼓励消费者在平台上消费，
          亦可兑现后提现。消费者提现，财务人工打款结算。
          </p>
        </div>
        <div class="col col-12 col-md-6 col-lg-6 text-top">
          <img class="my-col-8" :src="require('images/product/fl-exp.png')" />
        </div>
      </div>
    </div>
    <CommBrand />
    <CommFooter />
  </div>
</template>

<script>
import CommHeader from '@/components/CommHeader'
import CommSwipe from '@/components/CommSwipe'
import CommBrand from '@/components/CommBrand'
import CommFooter from '@/components/CommFooter'
export default {
  name: 'home',
  components: {
    CommHeader,
    CommSwipe,
    CommBrand,
    CommFooter
  },
  data () {
    return {
      swipeDataList: [{img: require('images/home/sw-img1.jpg'),
        caption: '返利APP',
        url: '#',
        describe: '这个场景我们将新零售业务系统与其商城打通，在线下商户消费也能返利，扩充了业务范围。同时提供了' +
          '“多场景全渠道收付款”收款支付通道，并且也支持平台积分付款，以及通过商户钱包解决了消费者的返利提现。'
      }]
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/product/Fl.vue